module.exports = __webpack_public_path__ + "static/media/bg-sabio.d312d5f5.svg";